export default {
  nav: {
    collection: 'Collection',
    scan: 'Scan',
    cards: 'Cards',
    profile: 'Profile',
  },
  common: {
    all: 'All',
    search: 'Search',
    cancel: 'Cancel',
    confirm: 'Confirm',
    noData: 'No data',
    success: 'Success',
    loading: 'Loading...',
    ownedOnly: 'Owned Only',
  },
  toast: {
    networkError: 'Network error, please check your connection.',
    timeout: 'Request timed out, please try again.',
    invalidRequest: 'Invalid request.',
    sessionExpired: 'Session expired, please sign in again.',
    accessDenied: 'Access denied.',
    notFound: 'Resource not found.',
    invalidParams: 'Invalid parameters.',
    tooManyRequests: 'Too many requests, please slow down.',
    serverError: 'Server error, please try again later.',
    loginRequired: 'Please sign in first.',
    addSuccess: 'Added to collection.',
    removeSuccess: 'Removed from collection.',
    quantityUpdated: 'Quantity updated.',
    saveSuccess: 'Saved successfully.',
    signOutSuccess: 'Signed out.',
    searchEmpty: 'Please enter a card ID.',
    uploadSuccess: 'Uploaded successfully.',
    notCamera: 'Camera access denied.',
    firstCard: 'This is the first card.',
    lastCard: 'This is the last card.',
    emailEmpty: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    codeEmpty: 'Enter 6-digit code',
  },
  signin: {
    subtitle: 'One Piece Card Tracker',
    emailLabel: 'Email Address',
    emailPlaceholder: 'captain@grandline.com',
    verificationCode: 'Verification Code',
    send: 'Send',
    resend: 'Resend',
    signIn: 'Sign In',
    autoRegister: 'New users will be registered automatically.',
  },
  collection: {
    searchPlaceholder: 'Search cards, sets, codes…',
    searchedCards: 'Results',
    totalValue: 'Total Collection Value',
    totalCards: 'Total Cards',
    sortHighToLow: 'Price: High to Low',
    sortLowToHigh: 'Price: Low to High',
    recentlyAdded: 'Recently Added',
    guestTitle: 'Start Your Collection',
    guestDesc: 'Sign in to track, manage and value your card collection.',
    guestFeature1: 'Track every card you own',
    guestFeature2: 'Monitor real-time market prices',
    guestFeature3: 'Scan cards instantly with your camera',
    emptyTitle: 'Your collection is empty',
    emptyDesc: 'Scan or search cards to start your collection',
    scanCards: 'Scan Cards',
    searchCards: 'Add by Search',
  },
  cardDetail: {
    title: 'Card Details',
    cardId: 'Card ID',
    rarity: 'Rarity',
    language: 'Language',
    version: 'Version',
    type: 'Type',
    foil: 'Foil',
    yourHolding: 'Your Holding',
    owned: 'Owned',
    market: 'Market Price',
    lastUpdated: 'Last Updated',
  },
  scan: {
    title: 'Scan',
    manual: 'Manual',
    alignCard: 'Align the card within the frame.',
    scanCard: 'Scan a card to get started.',
    scanBtn: 'Scan',
    searchCards: 'Search Cards',
    pointCamera: 'Point the camera at the card and hold steady.',
    unidentified: 'Card not identified.',
    cardsIdentified: 'cards identified',
    scanSuccess: 'Card identified.',
    cardLanguage: 'Card Language',
    cardId: 'Card ID',
    cardIdPlaceholder: 'e.g. OP01-060',
    tapToCapture: 'Tap the button below to take a photo.',
    takePhoto: 'Take Photo',
    fromAlbum: 'Choose from Album',
    clear: 'Clear',
  },
  cards: {
    searchPlaceholder: 'Search sets…',
    searchInSet: 'Search cards…',
    allSets: 'All Sets',
    of: 'of',
  },
  profile: {
    email: 'Email',
    language: 'Language',
    langEn: 'English',
    langZhTW: '繁體中文',
    editUsername: 'Edit Username',
    usernamePlaceholder: 'Enter a username.',
    saveUsername: 'Save',
    editAvatar: 'Change Avatar',
    signOut: 'Sign Out',
    guest: 'Start Your Collection',
    guestDesc: 'Sign in to unlock your full collection.',
    feature1: 'Track and manage your card collection',
    feature2: 'Monitor real-time market prices',
    feature3: 'Scan cards instantly with your camera',
  },
}
